<template>
    <div class="swipe-box" v-if="show">
        <van-swipe @change="swipeChaneg" :initial-swipe="lookIndex">
            <van-swipe-item v-for="(item, index) in arrUrl" :key="index">
                <div class="swipe-image" v-if="item.type == 'image'"><img :src="item.pic"/></div>
                <div v-if="item.type == 'video'" class="meng-img">
                    <video id="videoUrl" controls
                           :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"
                           :src="item.pic"/>
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="directive">{{ lookIndex + 1 }}/{{ arrUrl.length }}</div>
        <div class="swipe-close" @click="toClose">
            <img :src="require('@/assets/images/antV2/icon_close.png')"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "mediaPreview",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        arrUrl: {
            type: Array,
            default: []
        },
        nIndex: {
            type: Number,
            default: 0
        }
    },
    watch: {
        nIndex(value) {
            console.log(value,'value')
            this.lookIndex = value
        }
    },
    data() {
        return {
            lookIndex: 0
        }
    },
    methods: {
        swipeChaneg(e) {
            this.lookIndex = e
        },
        toClose() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
